module.exports = __webpack_public_path__ + "img/hr-red-croton-08.d7dec5bf.png";